import { callOrganizationServiceApi } from '../../../apis/organizationService';

/**
 * The page size this client asks for: organization-service's maximum
 * (`adminreads.PageLimitMax`). A larger value is refused with a 422, not
 * clamped.
 */
export const SALES_METROS_PAGE_LIMIT = 200;

/**
 * organization-service's offset ceiling (`adminreads.PageOffsetMax`). The
 * handler 422s any page whose offset would pass it.
 */
const SALES_METROS_OFFSET_MAX = 5000;

/**
 * The last page the endpoint serves at `SALES_METROS_PAGE_LIMIT`, derived the
 * way the handler derives it (`PageOffsetMax/limit + 1`, integer division).
 * Requesting the page after it is a 422, not an empty list.
 */
export const SALES_METROS_MAX_PAGE =
  Math.floor(SALES_METROS_OFFSET_MAX / SALES_METROS_PAGE_LIMIT) + 1;

/**
 * One page of the sales metro list, from organization-service.
 *
 * A falsy `zip` is omitted rather than sent empty: the handler validates it as
 * exactly five digits, so `zip=` is a 422 `invalid_zip`, not "no filter".
 *
 * @param {Object} [params]
 * @param {number} [params.page] - 1-based page index
 * @param {number} [params.limit] - Page size; 1-200, defaults to the maximum
 * @param {string} [params.zip] - A 5-digit zip; narrows to the one metro owning it
 * @returns {Promise<import('../types/SalesMetro.api').IGetSalesMetrosApiResponse>}
 */
export const getSalesMetros = ({ page = 1, limit = SALES_METROS_PAGE_LIMIT, zip } = {}) => {
  const params = { page, limit };
  if (zip) params.zip = zip;

  return callOrganizationServiceApi('get', 'admin/sales-metros', { params });
};
